'use client';

import { usePathname } from 'next/navigation';
import type { ReactNode } from 'react';
import { AppShell } from './AppShell';
import { BreadcrumbLeafProvider } from './BreadcrumbLeafContext';
import { MAIN_NAVIGATION } from './navigation';

interface AppShellBoundaryProps {
	children: ReactNode;
}

const SHELL_EXCLUDED_PREFIXES = [
	'/acceso',
	'/login',
	'/register',
	'/registro',
	'/completar-registro',
	'/forgot-password',
	'/recuperar-clave',
	'/reset-password',
	'/elegir-sistema',
];

export function AppShellBoundary({ children }: AppShellBoundaryProps) {
	const pathname = usePathname();

	if (isShellExcludedPath(pathname)) {
		return <>{children}</>;
	}

	return (
		<BreadcrumbLeafProvider>
			<AppShell navigation={MAIN_NAVIGATION}>
				{children}
			</AppShell>
		</BreadcrumbLeafProvider>
	);
}

function isShellExcludedPath(pathname: string) {
	return SHELL_EXCLUDED_PREFIXES.some(
		(prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
	);
}
